import React, { FC, ReactNode } from 'react';
import { useAppGate } from 'src/context/appGate';
import { CustomSpinner } from 'src/shared/Spinner';
import Maintenance from 'src/pages/MaintenancePage/MaintenancePage';

interface AppGateProps {
  children: ReactNode;
}

const AppGate: FC<AppGateProps> = ({ children }) => {
  const { status, maintenanceData } = useAppGate();

  switch (status) {
    case 'initializing':
      return <CustomSpinner overlay />;
    case 'maintenance':
      return <Maintenance text={maintenanceData?.text} />;
    case 'ready':
      return <>{children}</>;
  }
};

export default AppGate;
